<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="amzStoreCode"
      resizable
      auto-resize
      highlight-hover-row
      :height="800"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :cell-class-name="cellClassName"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayStore="{ row }">
        <span>NO：</span><span>{{ row.amzStoreNo }}</span>
        <br />
        <span>NAME：</span>
        <span style="color: #303133">{{ row.amzStoreName }}</span>
      </template>
      <template v-slot:displayAccount="{ row }">
        <span>ACCT：</span>
        <span style="color: #303133">{{ row.amzStoreAccount }}</span>
        <br />
        <span>SITE：</span>
        <span style="color: #303133">{{ row.v_amazonStoreRegion }}</span>
        <br />
        <span>CNTY：</span>
        <span style="color: #303133">{{ row.regionName }}</span>
      </template>
      <template v-slot:displayEcomCompanyName="{ row }">
        <span>ID：</span>
        <span style="color: #303133">{{ row.amzStoreId }}</span>
        <br />
        <span style="color: #303133">{{ row.ecomCompanyName }}</span>
      </template>
      <template v-slot:displayInvStoreName="{ row }">
        <span>{{ row.invStoreName }}</span>
        <br />
        <span>Own Inv:</span>
        <el-tag
          size="mini"
          class="ml-1"
          :type="row.isOwnInv === 'Y' ? 'success' : 'warning'"
        >
          {{ row.v_isOwnInv }}
        </el-tag>
        <br />
        <span>Currency：</span>
        <span style="color: #303133">{{ row.v_currency }}</span>
      </template>
      <template v-slot:displayCreditCard="{ row }">
        <span>Holder:</span>
        <span style="color: #303133">{{ row.creditCardHolder }}</span>
        <br />
        <span>No:</span>
        <span style="color: #303133">{{ row.creditCardNo }}</span>
        <br />
        <span>Expiry:</span>
        <span style="color: #303133">{{ row.expiryYearMonth }}</span>
      </template>
      <template v-slot:displayMobile="{ row }">
        <span>Mobile:</span>
        <span style="color: #303133">{{ row.loginMobile }}</span>
        <br />
        <span>Properties:</span>
        <span style="color: #303133">{{ row.mobileProperties }}</span>
        <br />
        <span>Ownership:</span>
        <span style="color: #303133">{{ row.mobileOwnership }}</span>
        <br />
        <span>Model:</span>
        <span style="color: #303133">{{ row.mobileModel }}</span>
      </template>
      <template v-slot:displayIP="{ row }">
        <span>Address:</span>
        <span style="color: #303133">{{ row.ipAddress }}</span>
        <br />
        <span>Country:</span>
        <span style="color: #303133">{{ row.ipCountry }}</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    cellClassName({ column }) {
      const { property } = column
      return property === 'col-opt' ? '' : 'align-top'
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
